{
  "name": "stylus",
  "description": "Robust, expressive, and feature-rich CSS superset",
  "version": "0.59.0",
  "author": "TJ Holowaychuk <tj@vision-media.ca>",
  "keywords": [
    "css",
    "parser",
    "style",
    "stylesheets",
    "jade",
    "language"
  ],
  "repository": {
    "type": "git",
    "url": "git://github.com/stylus/stylus"
  },
  "main": "./index.js",
  "browserify": "./lib/browserify.js",
  "engines": {
    "node": "*"
  },
  "bin": {
    "stylus": "./bin/stylus"
  },
  "scripts": {
    "prepublish": "npm prune",
    "test": "mocha test/ test/middleware/ --require chai --bail --check-leaks --reporter dot"
  },
  "dependencies": {
    "@adobe/css-tools": "^4.0.1",
    "debug": "^4.3.2",
    "glob": "^7.1.6",
    "sax": "~1.2.4",
    "source-map": "^0.7.3"
  },
  "devDependencies": {
    "chai": "^4.3.6",
    "mocha": "^9.2.0"
  },
  "bugs": {
    "url": "https://github.com/stylus/stylus/issues"
  },
  "homepage": "https://github.com/stylus/stylus",
  "directories": {
    "doc": "docs",
    "example": "examples",
    "test": "test"
  },
  "license": "MIT",
  "funding": "https://opencollective.com/stylus"
}
